// Components
import { MenuEntry } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntry';

// Types
import type { MenuEntryType } from '@/lib/platform/menu/menu';

export type MenuMobileEntriesProps = {
    activeEntry: string;
    setActiveEntry: (name: MenuEntryType['id']) => void;
    menuConfig: MenuEntryType[];
};

export function MenuMobileEntries({
    activeEntry,
    setActiveEntry,
    menuConfig
}: MenuMobileEntriesProps) {
    return (
        <div className="flex flex-col gap-4">
            {menuConfig.map((entry) => (
                <div key={entry.id} className="menu-entry cursor-pointer">
                    <MenuEntry
                        entry={entry}
                        isMenuOpen
                        isMenuMobile
                        activeEntry={activeEntry}
                        setActiveEntry={setActiveEntry}
                    />
                </div>
            ))}
        </div>
    );
}
